import { useState, useEffect } from 'react';

const BREAKPOINTS = {
  mobile: 640,    // sm
  tablet: 1024,   // lg
  desktop: 1280   // xl
};

export const useResponsiveView = () => {
  const [viewMode, setViewMode] = useState('table');
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      setWindowWidth(width);

      if (width < BREAKPOINTS.mobile) {
        setViewMode('cards');
      } else if (width < BREAKPOINTS.tablet) {
        setViewMode('cards');
      } else {
        setViewMode('table');
      }
    };

    // Initial check
    handleResize();

    // Add event listener
    window.addEventListener('resize', handleResize);

    // Cleanup
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return {
    viewMode,
    windowWidth,
    isMobile: windowWidth < BREAKPOINTS.mobile,
    isTablet: windowWidth >= BREAKPOINTS.mobile && windowWidth < BREAKPOINTS.tablet,
    isDesktop: windowWidth >= BREAKPOINTS.tablet
  };
}; 